import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TranslatedNamePipe } from './translated-name.pipe';

@NgModule({
  declarations: [TranslatedNamePipe],
  imports: [CommonModule],
  exports: [TranslatedNamePipe]
})
export class TranslatedNamePipeModule {}
